import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import Layout from "../layouts/Layout";
import Organizations from "../pages/Organization/Organization";
import Users from "../pages/Users/Users";
import Subscriptions from "../pages/Subscriptions/Subscription";
import Coupons from "../pages/Coupons/Coupons";
import Plans from "../pages/Plans/Plans";
import Transactions from "../pages/Transactions/Transactions";
import ViewUserDetails from "../pages/Users/pages/ViewUserDetails";
import AddNewUser from "../pages/Users/pages/AddNewUser";
import AddOrganization from "../pages/Organization/AddOrganization";
import QrGenerator from "../pages/QrGenerator/QrGenerator";
import Invoice from "../pages/Plans/Invoice";
import AddPlan from "../pages/Plans/AddPlan";
import AffiliateProgram from "../pages/AffiliateProgram/AffiliateAccount";
import KnowledgeBase from "../pages/KnowledgeBase/KnowledgeBase";
import AffiliateAccount from "../pages/AffiliateProgram/AffiliateAccount";
import AffiliateComission from "../pages/AffiliateProgram/Comission";
import AffiliatePayout from "../pages/AffiliateProgram/Payout";
import AffiliateReport from "../pages/AffiliateProgram/Report";
import AffiliateDashboard from "../pages/AffiliateProgram/Dashboard";
import AddKnowledgeCategory from "../pages/KnowledgeBase/AddKnowledgeCategory";
import KnowledgeBaseArticals from "../pages/KnowledgeBase/KnowledgeBaseArticals";
import AddKnowledgeCategoryArtical from "../pages/KnowledgeBase/AddKnowledgeCategoryArtical";
import CommissionTier from "../pages/AffiliateProgram/CommissionTier";
import MetaPricingSync from "../pages/MetaPricingSync/MetaPricingSync";
import SubscriptionNew from "../pages/Subscriptions/SubscriptionNew";
import AffiliateDetails from "../pages/AffiliateProgram/AffiliateDetails";
import UsersNew from "../pages/Users/UsersNew";
import PaymentHistory from "../pages/PaymentHistory/PaymentHistory";
import PricingStudio from "../pages/PricingStudio/PricingStudio";
import WhiteLabel from "../pages/WhiteLabel/WhiteLabel";



const AppRoutes = () => {
  const isAuthenticate = localStorage.getItem("USER_TOKEN")
  return (
    <Router>
      <Routes>
        <Route path="/" element={isAuthenticate ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/" element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/organizations-partner" element={<Organizations />} />
          <Route path="/organizations-partner/edit-organization/:id" element={<AddOrganization />} />
          <Route path="/organizations-partner/add-new-organization" element={<AddOrganization />} />

          <Route path="/users" element={<Users />} />
          <Route path="/customers-and-users" element={<UsersNew />} />
          <Route path="/customers-and-users/view-user/:id" element={<ViewUserDetails />} />
          <Route path="/customers-and-users/add-new-user" element={<AddNewUser />} />
          <Route path="/customers-and-users/edit-user/:id" element={<AddNewUser />} />
          <Route path="/affiliate-program/dashboard" element={<AffiliateDashboard />} />
          <Route path="/affiliate-program/account" element={<AffiliateAccount />} />
          <Route path="/affiliate-program/commission" element={<AffiliateComission />} />
          <Route path="/affiliate-program/commission/commission-tier" element={<CommissionTier />} />
          <Route path="/affiliate-program/payout" element={<AffiliatePayout />} />
          <Route path="/affiliate-program/report" element={<AffiliateReport />} />
          <Route path="/knowledge-base" element={<KnowledgeBase />} />
          <Route path="/knowledge-base-articals/:id" element={<KnowledgeBaseArticals />} />
          <Route path="/add-knowledge-category" element={<AddKnowledgeCategory />} />
          <Route path="/add-knowledge-category-artical/:categoryId/:articalId?" element={<AddKnowledgeCategoryArtical />} />
          <Route path="/billing-subscription" element={<Subscriptions />} />
          <Route path="/subscription" element={<SubscriptionNew />} />
          <Route path="/coupons-promo" element={<Coupons />} />
          <Route path="/plans-pricing" element={<Plans />} />
          <Route path="/add-plan" element={<AddPlan />} />
          <Route path="/add-plan/:id" element={<AddPlan />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/payment-history" element={<PaymentHistory />} />
          <Route path="/qr-code-generator" element={<QrGenerator />} />
          <Route path="/meta-pricing" element={<MetaPricingSync />} />
          <Route path="/meta-pricing/:userId" element={<MetaPricingSync />} />
          <Route path="/affiliate-details" element={<AffiliateDetails />} />
          <Route path="/pricing-studio" element={<PricingStudio />} />
          <Route path="/white-label" element={<WhiteLabel />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;


